import { render, staticRenderFns } from "./Mypage_Like.vue?vue&type=template&id=7b6f1230&"
import script from "./Mypage_Like.vue?vue&type=script&lang=js&"
export * from "./Mypage_Like.vue?vue&type=script&lang=js&"
import style0 from "./Mypage_Like.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports